<template>
  <div>
    <el-table
      :data="data">
      <el-table-column
        type="index"
        prop="id"
        :index="indexMethod"
        label="序号">
      </el-table-column>
      <el-table-column
        prop="created_at"
        label="时间">
      </el-table-column>
      <el-table-column
        prop="amount"
        label="到账金额">
      </el-table-column>
      <el-table-column
        prop="company_name"
        label="任务发布方">
      </el-table-column>
      <el-table-column
        prop="title"
        label="任务名称">
      </el-table-column>
    </el-table>
    <div class="task-pages">
      <pagination
        @paginationChange="paginationChange"
        :pageInfo="pageInfo">
      </pagination>
    </div>
  </div>
</template>

<script>
import api from '@/api/index'
import Pagination from '@/components/pagination/index.vue'
export default {
  components: {
    Pagination
  },
  data () {
    return {
      data: [],
      pageInfo: {
        pageNum: 1,
        pageSize: 5,
        total: 0
      }
    }
  },
  created () {
    this.showRevenue()
  },
  methods: {
    paginationChange (val) {
      this.pageNum = val
    },
    // 用户展示自身收益
    showRevenue () {
      api.profit({
        ...this.pageInfo
      }).then(res => {
        if (res.data.code === 0) {
          this.data = res.data.data.list
          this.pageInfo.total = res.data.data.total
          this.pageInfo.pageNum = res.data.data.currentPage
        } else {
          this.$message.error(res.data.message)
        }
      }).catch((error) => {
        console.log(error)
        this.$message.error('请求异常')
      })
    },
    indexMethod (index) {
      // 当前页数 - 1 * 每页数据条数 + index + 1
      return (this.pageInfo.pageNum - 1) * this.pageInfo.pageSize + index + 1
    }
  }
}
</script>

<style lang="scss" scoped>
.task-pages {
    margin-top: 20px;
    text-align: center;
}
</style>
